import { useUser } from "@/modules/user/stores"
import { Button } from "@/components/ui/button"
import ExplanatoryModal from "@/modules/flashcards/features/studying/explanatory-modal"
import { CircleAlert } from "lucide-react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useNoLifeAlert } from "@/modules/app/stores/use-no-life-alert"
import useCanContinueLearning from "@/modules/user/hooks/use-can-continue-learning"
import useEndFreeTrialModal from "@/modules/plans/stores/use-end-free-trial"
import { useFinishFreeTrial } from "@/modules/user/hooks/use-finish-free-trial"
import mixpanelClient from "@/services/mixpanel"
import { useRecordLifeUsage } from "@/modules/user/queries/use-record-life-usage"

export default function StudySection() {
  const { user, lifeUsage } = useUser()
  const navigate = useNavigate()
  const [openExplanatoryModal, setOpenExplanatoryModal] = useState<boolean>(false)
  const canContinueLearning = useCanContinueLearning()
  const { setIsOpen: openNoLifeAlert } = useNoLifeAlert()
  const { isTrialFinished } = useFinishFreeTrial()
  const { onToggle } = useEndFreeTrialModal()
  const { mutate: recordLifeUsage } = useRecordLifeUsage()

  const userIdsThatVisitedTheStudySection = JSON.parse(
    localStorage.getItem("userIdsThatVisitedTheStudySection") || "[]",
  ) as string[]

  const isNewUserInTheSection = !userIdsThatVisitedTheStudySection.includes(user.id)

  const handleOnStudy = () => {
    if (isTrialFinished) {
      onToggle()
      return
    }
    if (!canContinueLearning) {
      openNoLifeAlert(true)
      return
    }

    mixpanelClient.flashcards.startFlashcard({
      startDate: new Date().toISOString(),
      userPlan: user.activePlan.name,
      userName: user.name,
      userEmail: user.email,
    })

    if (lifeUsage.list.length < 5) {
      recordLifeUsage({ activityCategory: "FLASHCARD" })
    }

    if (isNewUserInTheSection) {
      setOpenExplanatoryModal(true)

      localStorage.setItem(
        "userIdsThatVisitedTheStudySection",
        JSON.stringify([...userIdsThatVisitedTheStudySection, user.id]),
      )
    } else {
      navigate("/flashcards/special-deck")
    }
  }

  const handleOnIcon = () => {
    setOpenExplanatoryModal(true)
  }

  return (
    <>
      <div className="mr-3 flex items-center gap-3">
        <Button onClick={handleOnStudy}>Estudiar</Button>

        <Button onClick={handleOnIcon} className="bg-transparent p-0">
          <CircleAlert className="!size-6 text-gray-500" />
        </Button>
      </div>

      <ExplanatoryModal
        isOpen={openExplanatoryModal}
        closeModal={() => setOpenExplanatoryModal(false)}
      />
    </>
  )
}
